import React from "react";
import "./style.css";

const PolicyText = ({ data }) => {
  if (!data) return null;

  return (
    <>
      {data.updated ? (
        <div className="modal__description">{data.updated}</div>
      ) : null}

      <div className="policy__content">
        {data.sections?.map((section, idx) => {
          if (section.type === "block") {
            return (
              <div className="policy__section" key={idx}>
                <div className="policy__heading">{section.heading}:</div>
                <ul className="policy__list">
                  {section.lines.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </div>
            );
          }

          if (section.type === "rights") {
            return (
              <div className="policy__section" key={idx}>
                <div className="policy__heading">{section.heading}:</div>
                <ol className="policy__rights">
                  {section.items.map((it) => (
                    <li key={it.key} className="policy__right">
                      <div className="policy__rightTitle">
                        <strong>
                          {it.key}. {it.title}
                        </strong>{" "}
                        <span className="policy__article">({it.article})</span>
                      </div>
                      <div className="policy__text">{it.text}</div>
                    </li>
                  ))}
                </ol>
              </div>
            );
          }

          // type === "text"
          return (
            <div className="policy__section" key={idx}>
              <div className="policy__heading">{section.heading}:</div>
              <p className="policy__text">{section.text}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PolicyText;
